import types, { ActionCreators } from './types';

const audienceComponentERR: ActionCreators['AudienceComponentERR'] = (
  audienceType,
  errorMessages,
  error,
) => ({
  type: types.AUDIENCE_COMPONENT_ERR,
  audienceType,
  errorMessages,
  error,
});

const audienceComponentOK: ActionCreators['AudienceComponentOK'] = (audienceType, id) => ({
  type: types.AUDIENCE_COMPONENT_OK,
  audienceType,
  id,
});

const audienceComponentsERR: ActionCreators['AudienceComponentsERR'] = (errorMessages, error) => ({
  type: types.AUDIENCE_COMPONENTS_ERR,
  errorMessages,
  error,
});

const audienceComponentsOK: ActionCreators['AudienceComponentsOK'] = () => ({
  type: types.AUDIENCE_COMPONENTS_OK,
});

const audienceConfigurationUpdate: ActionCreators['AudienceConfigurationUpdate'] = (
  audienceConfigurationKey,
  key,
  value,
) => ({
  type: types.AUDIENCE_CONFIGURATION_UPDATE,
  audienceConfigurationKey,
  key,
  value,
});

const audienceToggleUpdate: ActionCreators['AudienceToggleUpdate'] = (
  audienceConfigurationKey,
) => ({
  type: types.AUDIENCE_TOGGLE_UPDATE,
  audienceConfigurationKey,
});

const requestAudience: ActionCreators['RequestAudience'] = (id, audienceType) => ({
  type: types.REQUEST_AUDIENCE,
  id,
  audienceType,
});

const requestAudienceERR: ActionCreators['RequestAudienceERR'] = (errorMessages, error) => ({
  type: types.REQUEST_AUDIENCE_ERR,
  errorMessages,
  error,
});

const requestAudienceOK: ActionCreators['RequestAudienceOK'] = (selectedAudience) => ({
  type: types.REQUEST_AUDIENCE_OK,
  selectedAudience,
});

const requestAudiencesOK: ActionCreators['RequestAudiencesOK'] = () => ({
  type: types.REQUEST_AUDIENCES_OK,
});

const requestSegments: ActionCreators['RequestSegments'] = () => ({
  type: types.REQUEST_SEGMENTS,
});

const requestSegmentsERR: ActionCreators['RequestSegmentsERR'] = (errorMessages, error) => ({
  type: types.REQUEST_SEGMENTS_ERR,
  errorMessages,
  error,
});

const requestSegmentsOK: ActionCreators['RequestSegmentsOK'] = (segments) => ({
  type: types.REQUEST_SEGMENTS_OK,
  segments,
});

const resetInitialAudiencesState: ActionCreators['ResetInitialAudiencesState'] = (audiences) => ({
  type: types.RESET_INITIAL_AUDIENCES_STATE,
  audiences,
});

const actions = {
  audienceComponentERR,
  audienceComponentOK,
  audienceComponentsERR,
  audienceComponentsOK,
  audienceConfigurationUpdate,
  audienceToggleUpdate,
  requestAudience,
  requestAudienceERR,
  requestAudienceOK,
  requestAudiencesOK,
  requestSegments,
  requestSegmentsERR,
  requestSegmentsOK,
  resetInitialAudiencesState,
};
export default actions;
